<template>
<div>
  <BackBar title="جستجوی پیشرفته"/>
  <div class="d-flex justify-space-around text-center mt-5" id="searchHeaderNav">
    <router-link to="SearchUsers">
      <span class="font16px" :class="getClass('searchUsers')">
      <i class="fa-regular fa-user font16px"></i>
      کاربران
        </span>
    </router-link>
    <router-link to="SearchTags">
      <span class="font16px" :class="getClass('searchTags')">
        <i class="fa-solid fa-hashtag font16px"></i>
        هشتگ
      </span>
    </router-link>
    <router-link to="SearchProducts">
      <span class="font16px" :class="getClass('searchProducts')">
      <i class="fa-regular fa-bag-shopping font16px"></i>
      محصول
        </span>
    </router-link>
    <router-link to="SearchStores">
      <span class="font16px" :class="getClass('searchStores')">
      <i class="fa-regular fa-store font16px"></i>
      فروشگاه
        </span>
    </router-link>


  </div>
  </div>
</template>

<script>
import BackBar from "@/components/BackBar";
export default {
  name: "SearchNavHeader",
  components: {BackBar},
  props:['currentPage'],
  methods:{
    getClass(linkName) {
      let classList = "text-center search-header";
      if (linkName === this.currentPage) {
        classList += " active";
      }
      return classList;
    },
  }
}
</script>

<style scoped>

</style>
